module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"managing-partners":"Sócios","managing-partner":"Sócio {number}","add-managing-partner":"Adicionar sócio","remove-managing-partner":"Remover sócio"},"en-US":{"managing-partners":"Managing partners","managing-partner":"Managing partner {number}","add-managing-partner":"Add managing partner","remove-managing-partner":"Remove managing partner"}}')
  delete Component.options._Ctor
}
